/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

const barPlotNavigation = rawData => rawData.all.map(({ barPlot }) => barPlot.fields)

export default barPlotNavigation
